
import { useState } from 'react';
import Hero from './components/Hero';
import Products from './components/Products';
import Video from './components/Video';
import Conditions from './components/Conditions';
import FinancialSummary from './components/FinancialSummary';
import Contact from './components/Contact';
import Footer from './components/Footer';
import Lightbox from './components/Lightbox';
import LanguageSwitcher from './components/LanguageSwitcher';

export default function Home() {
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [currentImages, setCurrentImages] = useState<string[]>([]);
  const [currentIndex, setCurrentIndex] = useState(0);

  const openLightbox = (images: string[], index: number) => {
    setCurrentImages(images);
    setCurrentIndex(index);
    setLightboxOpen(true);
  };

  const closeLightbox = () => {
    setLightboxOpen(false);
  };

  return (
    <div className="min-h-screen bg-white">
      <LanguageSwitcher />
      <Hero />
      <Products onOpenLightbox={openLightbox} />
      <Video />
      <Conditions />
      <FinancialSummary />
      <Contact />
      <Footer />
      
      {lightboxOpen && (
        <Lightbox
          images={currentImages}
          currentIndex={currentIndex}
          onClose={closeLightbox}
          onIndexChange={setCurrentIndex}
        />
      )}
    </div>
  );
}